import * as z from "zod";
const errorMapping = {
    password_min_character: "signup.password_min_character",
    password_max_character: "signup.password_max_character",
    password_empty: "signup.password_empty",
    password_not_match: "signup.signup_confirm_passwords_invalid",
    email_empty: "signup.email_empty",
    email_invalid: "signup.email_invalid",
    mobile_empty: "signup.signup_mobile_empty",
    mobile_min_character: "signup.signup_mobile_min_character",
    mobile_max_character: "signup.signup_mobile_max_character",
    mobile_invalid: "signup.signup_mobile_invalid",
    confirmPassword_min_character: "signup.password_min_character",
    confirmPassword_empty: "signup.password_empty",
    password_not_have_uppercase: "signup.password_not_have_uppercase",
    password_not_have_lowercase: "signup.password_not_have_lowercase",
    password_not_have_number: "signup.password_not_have_number",
};

export const signupEmailValidatorSchema = z
    .object({
        email: z
            .string({
                required_error: errorMapping.email_empty,
            })
            .min(1, {
                message: errorMapping.email_empty,
            })
            .regex(/^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/, {
                message: errorMapping.email_invalid,
            }),
        password: z
            .string({
                required_error: errorMapping.password_empty,
            })
            .min(1, {
                message: errorMapping.password_empty,
            })
            .min(8, {
                message: errorMapping.password_min_character,
            })
            .max(20, {
                message: errorMapping.password_max_character,
            })
            .regex(/[A-Z]/, { message: errorMapping.password_not_have_uppercase })
            .regex(/[a-z]/, { message: errorMapping.password_not_have_lowercase })
            .regex(/[0-9]/, { message: errorMapping.password_not_have_number }),
        confirmPassword: z
            .string({
                required_error: errorMapping.confirmPassword_empty,
            })
            .min(1, {
                message: errorMapping.password_empty,
            })
            .min(8, {
                message: errorMapping.confirmPassword_min_character,
            })
            .max(20, {
                message: errorMapping.password_max_character,
            })
            .regex(/[A-Z]/, { message: errorMapping.password_not_have_uppercase })
            .regex(/[a-z]/, { message: errorMapping.password_not_have_lowercase })
            .regex(/[0-9]/, { message: errorMapping.password_not_have_number }),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: errorMapping.password_not_match,
        path: ["confirmPassword"],
    });

export type SignUpValidatorSchema = z.infer<typeof signupEmailValidatorSchema>;

export const signupMobileValidatorSchema = z.object({
    phone_number: z
        .string({
            required_error: errorMapping.mobile_empty,
        })
        .regex(/^[0-9]*$/, {
            message: errorMapping.mobile_invalid,
        })
        .min(10, {
            message: errorMapping.mobile_min_character,
        })
        .max(10, {
            message: errorMapping.mobile_max_character,
        }),
});

export type SignUpMobileValidatorSchema = z.infer<typeof signupMobileValidatorSchema>;
